export default function(survey, tabletId) {
  const answer = {
    survey: survey._id,
    survey_name: survey.name,
    tablet: tabletId,
    questions: [],
  }

  survey.questions.forEach((question) => {
    let thisAnswer = {};

    switch (question.type) {

      case "text":
      case "email":
      case "phone":
        thisAnswer = {
          text: '',
        };
        break;

      case "options":
        thisAnswer = {
          text: '',
          options: [],
        };
        break;

      case "stars5":
        thisAnswer = {
          stars: undefined,
        };
        break;

      case "grades10":
        thisAnswer = {
          grade: undefined,
        };
        break;

      case "statement":
        thisAnswer = {
          statement: undefined,
        };
        break;

      case "date":
        thisAnswer = {
          date: undefined,
        };
        break;

      case "emotions":
        thisAnswer = {
          emotion: undefined,
        };
        break;
    }

    answer.questions.push({
      ...question,
      answer: thisAnswer,
    });
  });

  return answer;
}
